import { createSelector } from 'reselect';

const REDUCER_NAME = 'liveCasino';

// [REDUCER_NAME]? , a question mark here is for search component
// if casino, or liveCasino, or allGames undefined in the store to not crash app
// some of them can be empty because we use explore page with categories, and without
// games without categories store in allGames reducer

export const campaignsSelector = state => state[REDUCER_NAME]?.campaigns;
export const gamesByGameCodeSelector = state => state[REDUCER_NAME]?.games;
export const hydratedSelector = state => state[REDUCER_NAME]?.hydrated;
export const loadingSelector = state => state[REDUCER_NAME]?.loading;
export const gameCodesByIdxSelector = state => state[REDUCER_NAME]?.gameCodesByIdx;
export const gameNamesByIdxSelector = state => state[REDUCER_NAME]?.gameNamesByIdx;
export const gameCodesByProviderCodeSelector = state => state[REDUCER_NAME]?.gameCodesByProviderCode;
export const gameCodesBySubProviderCodeSelector = state => state[REDUCER_NAME]?.gameCodesBySubProviderCode;
export const providersSelector = state => state[REDUCER_NAME]?.providers;
export const subProvidersSelector = state => state[REDUCER_NAME]?.subProviders;
export const liveCasinoDataSelector = state => state[REDUCER_NAME]?.liveCasinoData;
export const carouselItemsSelector = state => state[REDUCER_NAME].carouselItems;
export const exploreCategoriesSelector = state => state[REDUCER_NAME].exploreCategories;
export const exploreLiveCasinoStatusSelector = state => state[REDUCER_NAME].exploreLiveCasinoStatus;
export const mediaTypeSelector = state => state.browser?.mediaType;
export const categoriesByCategoryIdSelector = categoryId => state =>
	state[REDUCER_NAME]?.exploreCategories.find(category => category.id === categoryId);

export const gamesByIndexSelector = createSelector(
	[gamesByGameCodeSelector, gameCodesByIdxSelector],
	(gamesByGameCode, gameCodes) => {
		return gameCodes?.reduce((acc, gameCode, idx) => {
			acc[idx] = gamesByGameCode[gameCode];
			return acc;
		}, {});
	}
);

export const gamesByNameSelector = createSelector(
	[gameNamesByIdxSelector, gameCodesByIdxSelector, gamesByGameCodeSelector],
	(gameNames, gameCodes, gamesByGameCode) => {
		return gameCodes?.reduce((acc, gameCode, idx) => {
			acc[gameNames[idx]] = gamesByGameCode[gameCode];
			return acc;
		}, {});
	}
);

export const gameLiveCasinoDataSelector = createSelector(
	liveCasinoDataSelector,
	(_, game) => game,
	(liveCasinoData, game) => {
		const providerLiveData = liveCasinoData?.find(
			data => data.provider === game?.provider?.code.replace('_MOBILE', '')
		);
		const pubCode = game?.publishCode?.split('_').reverse()[0];
		return providerLiveData?.gameStates?.[pubCode];
	}
);
